/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/* Staging Changes */

function fixSlickAccessibility() {
  document.querySelectorAll('.slick-slide[aria-hidden="true"]').forEach(function (slide) {
    slide.setAttribute('tabindex', '-1');

    slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  });

  document.querySelectorAll('.slick-slide[aria-hidden="false"]').forEach(function (slide) {
    slide.removeAttribute('tabindex');

    slide.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  fixSlickAccessibility();

  setTimeout(fixSlickAccessibility, 500);
  setTimeout(fixSlickAccessibility, 1500);
});

document.addEventListener('shopify:section:load', fixSlickAccessibility);
 

if (window.jQuery) {
  jQuery(document).on('init afterChange setPosition', '.slick-slider', function () {
    fixSlickAccessibility();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('button:not([aria-label])').forEach(function (button) {
    if (!button.textContent.trim()) {
      button.setAttribute('aria-label', 'Open media');
    }
  });
});


function fixAccessibilityIssues() {
  // Fix Slick hidden slides focus issue
  document.querySelectorAll('.slick-slide[aria-hidden="true"]').forEach(function (slide) {
    slide.setAttribute('tabindex', '-1');

    slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  });

  document.querySelectorAll('.slick-slide[aria-hidden="false"]').forEach(function (slide) {
    slide.removeAttribute('tabindex');

    slide.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  });

  // Fix empty buttons
  document.querySelectorAll('button:not([aria-label])').forEach(function (button) {
    if (!button.textContent.trim()) {
      button.setAttribute('aria-label', 'Open media');
    }
  });

  document.querySelectorAll('.logo-list__item').forEach((item, index) => {
  if (item.tagName.toLowerCase() === 'a') {
    item.setAttribute(
      'aria-label',
      `Open featured publication link ${index + 1}`
    );
    item.setAttribute(
      'title',
      `Open featured publication link ${index + 1}`
    );
  } else {
    item.removeAttribute('aria-label');
    item.removeAttribute('title');
  }
});

  // Fix missing alt on images
  document.querySelectorAll('img:not([alt])').forEach(function (img) {
    img.setAttribute('alt', '');
    img.setAttribute('role', 'presentation');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  fixAccessibilityIssues();

  setTimeout(fixAccessibilityIssues, 500);
  setTimeout(fixAccessibilityIssues, 1500);
  setTimeout(fixAccessibilityIssues, 3000);
});

document.addEventListener('shopify:section:load', fixAccessibilityIssues);

if (window.jQuery) {
  jQuery(document).on('init afterChange setPosition', '.slick-slider', function () {
    fixAccessibilityIssues();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="https://styledsettings.com"], a[href="https://styledsettings.com/"]').forEach(function (link) {
    if (!link.textContent.trim() && !link.getAttribute("aria-label")) {
      link.setAttribute("aria-label", "Styled Settings home");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("button a").forEach(function (link) {
    var span = document.createElement("span");
    span.textContent = link.textContent.trim();
    span.className = link.className || "";
    link.replaceWith(span);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Fix empty home/logo links
  document.querySelectorAll('a[href="https://styledsettings.com"], a[href="https://styledsettings.com/"]').forEach(function (link) {
    if (!link.textContent.trim() && !link.getAttribute("aria-label")) {
      link.setAttribute("aria-label", "Styled Settings home");
    }
  });

  // Fix nested interactive controls: remove focusable links inside buttons
  document.querySelectorAll("button a").forEach(function (link) {
    var span = document.createElement("span");
    span.textContent = link.textContent.trim();
    span.className = link.className || "";
    link.replaceWith(span);
  });
});

(function () {
  var a11yTimer;

  function updateFocusableElements(container, shouldDisable) {
    if (!container) return;

    var focusableElements = container.querySelectorAll(
      'a, button, input, select, textarea, summary, [tabindex]'
    );

    focusableElements.forEach(function (el) {
      if (shouldDisable) {
        if (!el.hasAttribute('data-a11y-original-tabindex')) {
          el.setAttribute('data-a11y-original-tabindex', el.getAttribute('tabindex') || '');
        }

        el.setAttribute('tabindex', '-1');

        if (
          el.tagName === 'BUTTON' ||
          el.tagName === 'INPUT' ||
          el.tagName === 'SELECT' ||
          el.tagName === 'TEXTAREA'
        ) {
          if (!el.disabled) {
            el.setAttribute('data-a11y-temp-disabled', 'true');
            el.disabled = true;
          }
        }
      } else {
        if (el.hasAttribute('data-a11y-original-tabindex')) {
          var originalTabindex = el.getAttribute('data-a11y-original-tabindex');

          if (originalTabindex) {
            el.setAttribute('tabindex', originalTabindex);
          } else {
            el.removeAttribute('tabindex');
          }

          el.removeAttribute('data-a11y-original-tabindex');
        }

        if (el.getAttribute('data-a11y-temp-disabled') === 'true') {
          el.disabled = false;
          el.removeAttribute('data-a11y-temp-disabled');
        }
      }
    });
  }

  function fixProductPageAccessibility() {
    // Rebuy: hidden recommendation products should not contain focusable elements
    document.querySelectorAll(
      '.rebuy-product-block[aria-hidden="true"], [aria-hidden="true"] .rebuy-product-block, [aria-label="product"][aria-hidden="true"]'
    ).forEach(function (block) {
      updateFocusableElements(block, true);
    });

    // Rebuy: visible products should remain usable
    document.querySelectorAll(
      '.rebuy-product-block[aria-hidden="false"], [aria-label="product"][aria-hidden="false"], .rebuy-product-block:not([aria-hidden="true"])'
    ).forEach(function (block) {
      if (!block.closest('[aria-hidden="true"]')) {
        updateFocusableElements(block, false);
      }
    });

    // Judge.me: role="img" should not contain focusable link descendants
    document.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]').forEach(function (el) {
      el.setAttribute('role', 'group');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixProductPageAccessibility();
    setTimeout(fixProductPageAccessibility, 500);
    setTimeout(fixProductPageAccessibility, 1500);
    setTimeout(fixProductPageAccessibility, 3000);
  });

  window.addEventListener('load', function () {
    fixProductPageAccessibility();
    setTimeout(fixProductPageAccessibility, 1000);
    setTimeout(fixProductPageAccessibility, 3000);
  });

  document.addEventListener('shopify:section:load', fixProductPageAccessibility);

  new MutationObserver(function () {
    clearTimeout(a11yTimer);
    a11yTimer = setTimeout(fixProductPageAccessibility, 150);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'class', 'style']
  });
})();

(function () {
  function fixZCartAccessibility() {
    // Fix zcart close buttons
    document.querySelectorAll(".zcart-close-btn").forEach(function (button) {
      button.setAttribute("aria-label", "Close cart");
      button.setAttribute("title", "Close cart");
      button.setAttribute("type", "button");

      button.querySelectorAll("svg").forEach(function (svg) {
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
      });
    });

    // Fix zcart product images missing alt
    document.querySelectorAll(".zcart-c-item img, .zcart-upsell img").forEach(function (img) {
      if (!img.hasAttribute("alt") || img.getAttribute("alt").trim() === "") {
        var productBlock = img.closest(".zcart-c-item, .zcart-upsell, .zcart-upsell-product");
        var productName = "";

        if (productBlock) {
          var titleEl = productBlock.querySelector(
            ".zcart-product-title, .zcart-title, .title, a, h3, h4, p"
          );

          if (titleEl && titleEl.textContent.trim()) {
            productName = titleEl.textContent.trim();
          }
        }

        img.setAttribute("alt", productName || "Product image");
      }
    });

    // Fix quantity inputs missing label
    document.querySelectorAll(".zcart-c-item input.quantity-input, input.quantity-input[name='updates[]']").forEach(function (input) {
      if (!input.getAttribute("aria-label")) {
        input.setAttribute("aria-label", "Product quantity");
      }

      input.setAttribute("title", "Product quantity");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    fixZCartAccessibility();

    setTimeout(fixZCartAccessibility, 500);
    setTimeout(fixZCartAccessibility, 1500);
    setTimeout(fixZCartAccessibility, 3000);
  });

  window.addEventListener("load", function () {
    fixZCartAccessibility();

    setTimeout(fixZCartAccessibility, 1000);
    setTimeout(fixZCartAccessibility, 3000);
  });

  document.addEventListener("click", function () {
    setTimeout(fixZCartAccessibility, 300);
    setTimeout(fixZCartAccessibility, 1000);
  });

  new MutationObserver(function () {
    fixZCartAccessibility();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();



(function () {
  function hideDecorativeSvgs() {
    document.querySelectorAll(
      '.icon--facebook, .icon--instagram, .icon--pinterest, .icon--tiktok, .icon--header-search, .icon--header-customer, .icon--header-tote-bag, .icon--picto-delivery-truck, .icon--picto-coupon'
    ).forEach(function (svg) {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('role', 'presentation');
      svg.setAttribute('focusable', 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', hideDecorativeSvgs);
  window.addEventListener('load', hideDecorativeSvgs);
  document.addEventListener('shopify:section:load', hideDecorativeSvgs);
})();


(function () {
  function fixAriaLabelOverrides() {
    document.querySelectorAll('button[id^="btn_"][aria-label]').forEach(function (button) {
      var visibleText = button.textContent.trim();

      if (visibleText.startsWith("@")) {
        button.removeAttribute("aria-label");

        if (!button.querySelector(".visually-hidden")) {
          var span = document.createElement("span");
          span.className = "visually-hidden";
          span.textContent = " view customer review";
          button.appendChild(span);
        }
      }
    });

    document.querySelectorAll('a[href*="instagram.com"][aria-label]').forEach(function (link) {
      if (link.textContent.trim().startsWith("@")) {
        link.removeAttribute("aria-label");

        if (!link.querySelector(".visually-hidden")) {
          var span = document.createElement("span");
          span.className = "visually-hidden";
          span.textContent = " on Instagram";
          link.appendChild(span);
        }
      }
    });

    document.querySelectorAll('a[href="/cart"][aria-label="Cart"]').forEach(function (link) {
      link.removeAttribute("aria-label");

      if (!link.querySelector(".visually-hidden")) {
        var span = document.createElement("span");
        span.className = "visually-hidden";
        span.textContent = "Cart";
        link.appendChild(span);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", fixAriaLabelOverrides);
  window.addEventListener("load", fixAriaLabelOverrides);
  setTimeout(fixAriaLabelOverrides, 1000);
})();


(function () {
  function fixScrollableCarouselAccessibility() {
    document.querySelectorAll(".text-with-icons__list.hide-scrollbar").forEach(function (el) {
      el.setAttribute("tabindex", "0");
      el.setAttribute("role", "region");

      if (!el.getAttribute("aria-label")) {
        el.setAttribute("aria-label", "Text with icons carousel");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", fixScrollableCarouselAccessibility);
  window.addEventListener("load", fixScrollableCarouselAccessibility);
  document.addEventListener("shopify:section:load", fixScrollableCarouselAccessibility);
})();

(function () {
  var a11yTimer;

  function runAccessibilityFixes() {
    // Slick hidden slides should not be focusable
    document.querySelectorAll('.slick-slide[aria-hidden="true"]').forEach(function (slide) {
      slide.setAttribute("tabindex", "-1");

      slide.querySelectorAll("a, button, input, select, textarea, summary, [tabindex]").forEach(function (el) {
        el.setAttribute("tabindex", "-1");
      });
    });

    document.querySelectorAll('.slick-slide[aria-hidden="false"]').forEach(function (slide) {
      if (slide.classList.contains("slick-active")) {
        slide.removeAttribute("tabindex");
      }

      slide.querySelectorAll("a, button, input, select, textarea, summary").forEach(function (el) {
        el.removeAttribute("tabindex");
      });
    });

    // UGC media buttons need accessible names
    document.querySelectorAll('button[id^="btn2_"]').forEach(function (button) {
      button.setAttribute("aria-label", "Open customer review media");
      button.setAttribute("title", "Open customer review media");
      button.setAttribute("type", "button");
    });

    // Remove nested links inside UGC buttons
    document.querySelectorAll('button[id^="btn_"] a').forEach(function (link) {
      var span = document.createElement("span");
      span.textContent = link.textContent.trim();
      link.replaceWith(span);
    });

    document.querySelectorAll('button[id^="btn_"]').forEach(function (button) {
      button.setAttribute("type", "button");

      if (!button.querySelector(".visually-hidden")) {
        var hidden = document.createElement("span");
        hidden.className = "visually-hidden";
        hidden.textContent = " view customer review";
        button.appendChild(hidden);
      }

      button.removeAttribute("aria-label");
    });

    // Missing alt attributes
    document.querySelectorAll("img:not([alt])").forEach(function (img) {
      img.setAttribute("alt", "");
      img.setAttribute("role", "presentation");
    });

    // Empty logo/publication links
    document.querySelectorAll(".logo-list__item").forEach(function (link, index) {
      if (!link.textContent.trim() && !link.getAttribute("aria-label")) {
        var href = link.getAttribute("href") || "";
        var label = "Open featured publication link " + (index + 1);

        if (href.includes("buzzfeed")) label = "Read Styled Settings feature on BuzzFeed";
        if (href.includes("foodandwine")) label = "Read Styled Settings feature on Food and Wine";
        if (href.includes("usmagazine")) label = "Read Styled Settings feature on Us Weekly";
        if (href.includes("yahoo")) label = "Read Styled Settings feature on Yahoo";
        if (href.includes("robbreport")) label = "Read Styled Settings feature on Robb Report";

        link.setAttribute("aria-label", label);
        link.setAttribute("title", label);
      }
    });

    // Empty footer/home links
    document.querySelectorAll('a[href="https://styledsettings.com"], a[href="https://styledsettings.com/"]').forEach(function (link) {
      if (!link.textContent.trim() && !link.getAttribute("aria-label")) {
        link.setAttribute("aria-label", "Styled Settings home");
        link.setAttribute("title", "Styled Settings home");
      }
    });

    // Powered by Shopify empty link
    document.querySelectorAll('a[href*="shopify.com"]').forEach(function (link) {
      if (!link.textContent.trim() && !link.getAttribute("aria-label")) {
        link.setAttribute("aria-label", "Powered by Shopify");
        link.setAttribute("title", "Powered by Shopify");
      }
    });

    // Viewport zoom fix
    document.querySelectorAll('meta[name="viewport"]').forEach(function (meta) {
      meta.setAttribute("content", "width=device-width, initial-scale=1.0");
    });

    // Preview bar iframe title, only if present
    var pbar = document.getElementById("PBarNextFrame");
    if (pbar) {
      pbar.setAttribute("title", "Shopify preview bar");
    }
  }

  function scheduleAccessibilityFixes() {
    clearTimeout(a11yTimer);
    a11yTimer = setTimeout(runAccessibilityFixes, 200);
  }

  document.addEventListener("DOMContentLoaded", function () {
    runAccessibilityFixes();
    setTimeout(runAccessibilityFixes, 500);
    setTimeout(runAccessibilityFixes, 1500);
    setTimeout(runAccessibilityFixes, 3000);
  });

  window.addEventListener("load", runAccessibilityFixes);
  document.addEventListener("shopify:section:load", runAccessibilityFixes);
  document.addEventListener("click", scheduleAccessibilityFixes);

  if (document.body) {
    new MutationObserver(scheduleAccessibilityFixes).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-hidden", "tabindex", "class"]
    });
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  var pbar = document.getElementById("PBarNextFrame");
  if (pbar) {
    pbar.setAttribute("title", "Shopify preview bar");
  }
});



(function () {
  function loadVideo(video) {
    if (!video || video.dataset.loaded === "true") return;

    var src = video.getAttribute("data-src");
    if (!src) return;

    video.src = src;
    video.dataset.loaded = "true";
    video.load();
  }

  function lazyLoadVideos() {
    var videos = document.querySelectorAll("video.lazy-video[data-src]");

    if (!("IntersectionObserver" in window)) {
      videos.forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: "300px 0px"
    });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  document.addEventListener("DOMContentLoaded", lazyLoadVideos);
})();

(function () {
  function loadVideo(video) {
    if (!video || video.dataset.loaded === "true") return;

    var src = video.getAttribute("data-src");
    if (!src) return;

    video.src = src;
    video.dataset.loaded = "true";
    video.load();
  }

  function lazyLoadVideos() {
    var videos = document.querySelectorAll("video.lazy-video[data-src]");

    if (!("IntersectionObserver" in window)) {
      videos.forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: "300px 0px"
    });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  document.addEventListener("DOMContentLoaded", lazyLoadVideos);
})();


function initializeNewsletterPopup() {
  const popup = document.querySelector('#newsletter-popup');

  if (!popup || sessionStorage.getItem('newsletterPopupShown')) {
    return;
  }

  const popupImage = popup.querySelector('[data-src]');

  if (popupImage?.dataset.src) {
    popupImage.src = popupImage.dataset.src;
    popupImage.removeAttribute('data-src');
  }

  popup.hidden = false;
  popup.setAttribute('aria-hidden', 'false');
  sessionStorage.setItem('newsletterPopupShown', 'true');
}

window.addEventListener(
  'load',
  () => {
    window.setTimeout(initializeNewsletterPopup, 4000);
  },
  { once: true }
);

const slider = document.querySelector('.slider');

if (slider && typeof Slider !== 'undefined') {
  new Slider(slider);
}

if (typeof handleScroll === 'function') {
  window.addEventListener('scroll', handleScroll, {
    passive: true
  });
}

function debounce(callback, delay = 150) {
  let timeoutId;

  return (...args) => {
    window.clearTimeout(timeoutId);

    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, delay);
  };
}

window.addEventListener(
  'resize',
  debounce(() => {
    // Resize functionality
  }),
  { passive: true }
);